import { Directive, ElementRef, EventEmitter, HostBinding, HostListener, Input, Output } from '@angular/core';
import type { FileLocation } from './file-tree.component';

export const FILE_MOVE_TYPE = 'application/x-bestroute-file-move';

/** Shared native drop interaction for tree folders and collection folders.
 * The page owns permissions, the dragged file and the actual move request. */
@Directive({ selector: '[fileDropTarget]', standalone: true })
export class FileDropTargetDirective {
  @Input() fileDropTarget: FileLocation | null = null;
  @Input() canDropFile: (location: FileLocation) => boolean = () => false;
  @Output() fileDropped = new EventEmitter<FileLocation>();
  @HostBinding('class.br-interactive--selected') active = false;
  constructor(private host: ElementRef<HTMLElement>) {}

  @HostListener('dragover', ['$event'])
  over(event: DragEvent): void {
    if (!event.dataTransfer?.types.includes(FILE_MOVE_TYPE) || !this.fileDropTarget) return;
    event.preventDefault(); event.stopPropagation();
    this.active = this.canDropFile(this.fileDropTarget);
    event.dataTransfer.dropEffect = this.active ? 'move' : 'none';
  }
  @HostListener('dragleave', ['$event'])
  leave(event: DragEvent): void {
    if (!(event.relatedTarget instanceof Node) || !this.host.nativeElement.contains(event.relatedTarget)) this.active = false;
  }
  @HostListener('drop', ['$event'])
  drop(event: DragEvent): void {
    if (!event.dataTransfer?.types.includes(FILE_MOVE_TYPE) || !this.fileDropTarget) return;
    event.preventDefault(); event.stopPropagation(); this.active = false;
    if (this.canDropFile(this.fileDropTarget)) this.fileDropped.emit(this.fileDropTarget);
  }
  @HostListener('document:dragend')
  end(): void { this.active = false; }
}
